import React from 'react';
import { Col } from 'react-bootstrap';
import './results.scss';

export const Procedures = (props) => {
  return <Col md={4} className="pc0"></Col>;
};
